export default "__VITE_ASSET__baf71cf9__"